export default __webpack_public_path__ + "assets/Manager2.png";